import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { HeroBannerSlider, BANNERS } from "@/components/HeroBannerSlider";
import { SaleCountdown } from "@/components/SaleCountdown";
import PickYourSetSection from "@/components/PickYourSetSection";
import CinematicDivider from "@/components/CinematicDivider";
import CategoryCircles from "@/components/CategoryCircles";
import AnnouncementMarquee from "@/components/AnnouncementMarquee";
import ShopByCategory from "@/components/ShopByCategory";
import FeaturedCollections from "@/components/FeaturedCollections";
import NewArrivals from "@/components/NewArrivals";
import Bestsellers from "@/components/Bestsellers";
import BrandStory from "@/components/BrandStory";
import InstaReels from "@/components/InstaReels";
import TrustBadges from "@/components/TrustBadges";
import ChunkyCuffsBanner from "@/components/ChunkyCuffsBanner";
import OceanCollectionStrip from "@/components/OceanCollectionStrip";
import FilmWall from "@/components/FilmWall";

const HomePage = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 },
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div data-testid="home-page">
      <HeroBannerSlider slides={[BANNERS.general, BANNERS["it-girl"], BANNERS.glam, BANNERS.dream]} />
      <div className="bg-cream border-b border-gold/20" data-testid="home-sale-strip">
        <div className="max-w-[1200px] mx-auto px-4 py-2.5 sm:py-3 flex items-center justify-center gap-4 sm:gap-8">
          <SaleCountdown />
          <Link
            to="/shop?filter=new"
            className="flex-shrink-0 px-5 sm:px-8 py-2.5 sm:py-3 rounded-full text-[10px] sm:text-[11px] tracking-[0.28em] uppercase font-semibold text-cream transition-transform hover:-translate-y-0.5"
            style={{ background: "#D4537E", boxShadow: "0 12px 26px -14px rgba(212,83,126,0.7)" }}
            data-testid="hero-cta-shop"
          >
            Shop Now
          </Link>
        </div>
      </div>
      <PickYourSetSection />
      <CategoryCircles />
      <AnnouncementMarquee />
      <CinematicDivider />
      <ShopByCategory />
      <FilmWall />
      <NewArrivals />
      <FeaturedCollections />
      <ChunkyCuffsBanner />
      <OceanCollectionStrip />
      <Bestsellers />
      <BrandStory />
      <InstaReels />
      <TrustBadges />
    </div>
  );
};

export default HomePage;
